export const JWM_VIDEO_PLAYER_ID = "ZDwb4uuwil";
export const JWM_VIDEO_PLAYER_INTERACTIVE_ID = "S13aKYHHrf";
export const JWM_VIDEO_APP_ID = "Janssen With Me 2.0";
export const JWM_VIDEO_ACCOUNT_ID = "1475651728001";
